<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key">Currency:</span>
          <span class="value">
            <gtd-ui-field-default-currency [data]="data.currency_code"></gtd-ui-field-default-currency>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Status:</span>
          <span class="value">
            <gtd-invoice-status [data]="data.status"> </gtd-invoice-status>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Payment System:</span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.payment_system"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Payout:</span>
          <span class="value">
            <gtd-ui-field-default-money [data]="data.payout"></gtd-ui-field-default-money>
          </span>
        </p>
      </li>
      <ng-container *ngIf="paymentDetails">
        <li *ngFor="let item of paymentDetails | keyvalue">
          <p>
            <span class="key">{{ item.key }}:</span>
            <span class="value">
              <gtd-ui-field-default-protected [data]="item.value"></gtd-ui-field-default-protected>
            </span>
          </p>
        </li>
      </ng-container>
      <li *ngIf="!paymentDetails">
        <p>
          <span class="key">Payment Details:</span>
          <span class="value">
            <gtd-ui-field-default-protected></gtd-ui-field-default-protected>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Manual Invoice:</span>
          <span class="value">
            <gtd-ui-field-default-boolean [data]="data?.manual"> </gtd-ui-field-default-boolean>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title">Other Info</li>
      <li>
        <p>
          <span class="key">Affiliate:</span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/affiliates/affiliates', data?.affiliate?.id]"
              [displayData]="data?.affiliate?.name"
              [relationData]="data?.affiliate?.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_AFFILIATE_TRACKERS_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Note:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.note"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Decline Note:</span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.decline_note"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title">Timestamps</li>
      <li>
        <p>
          <span class="key">Created At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Updated At:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">Start Date:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.start_date"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key">End Date:</span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.end_date"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
